import { Box, Paper, Stack, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Modal } from "@mui/material";
import { CatBtn, Container } from "../styledComponent/Common";
import { getStatusColor } from "../../pages/customer/form/DetailsForm";
import { LockerStatus } from "../../pages/customer/CustomerConstants";
import { Verified } from "@mui/icons-material";
import { cancelStyle } from "../modal/cancelModalStyle";
import { useState } from "react";
import { endpoints } from "../../api/endpoints";
import { toast } from "react-toastify";
import { useCrudForm } from "../../api/useCrudForm";
import { TableHeadCell } from "../styledComponent/table/TableCell";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { LoadingButton } from "@mui/lab";

const AccessibleLocker = ({ customerId, customerLocker, setIsApproved, isPrint }: { customerId: any, customerLocker?: any, setIsApproved?: any, isPrint?: boolean }) => {
    return (
        <Container sx={{ width: "100%", marginTop: `${isPrint ? "0px" : "15px"}`, paddingTop: '0 !important' }}>
            <Box sx={{ width: "100%" }}>
                <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                    Accessible Locker
                </Typography>
                <AccessibleLockerTable customerId={customerId} customerLocker={customerLocker} setIsApproved={setIsApproved} />
            </Box>
        </Container>
    )
}

export default AccessibleLocker

const AccessibleLockerTable = ({ customerId, customerLocker, setIsApproved }: { customerId: number, customerLocker?: any, setIsApproved?: any }) => {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [lockerId, setLockerId] = useState<any>(null);
    const [lockerNumber, setLockerNumber] = useState<any>(null);

    const handleClose = () => {
        setIsLoading(false)
        setOpen(false)
        setLockerId(null)
        setLockerNumber(null)
    }
    const { edit } = useCrudForm()

    const handleApproveLocker = () => {
        if (lockerId) {
            setIsLoading(true)
            edit({
                endpoints: endpoints.locker.verify(lockerId, customerId),
                onSuccess: (data: any) => {
                    if (data?.data === 1) {
                        customerLocker?.map((locker: any) => {
                            if (locker?.lockerId === lockerId) {
                                locker.lockerstatus = 2
                                locker.isVerified = true
                                if (setIsApproved) {
                                    setIsApproved(true)
                                }
                            }
                            return locker
                        })
                    }
                    handleClose()
                    toast.success(data?.message ?? 'Successfully Approved', { style: { background: '#3150A1' } })
                },
                onError: (error: any) => {
                    setIsLoading(false)
                    toast.error(error?.message ?? error)
                },
                values: {}
            })
        }
    }
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeadCell>SN</TableHeadCell>
                        <TableHeadCell>Locker</TableHeadCell>
                        <TableHeadCell>Type</TableHeadCell>
                        <TableHeadCell>Discount(%)</TableHeadCell>
                        <TableHeadCell>Assigned/Renewed On</TableHeadCell>
                        <TableHeadCell>Expiring On</TableHeadCell>
                        <TableHeadCell>Locker Status</TableHeadCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {customerLocker && customerLocker?.length > 0 ? customerLocker?.map((locker: any, index: number) => (
                        <TableRow key={index}
                            sx={{
                                "&:last-child td, &:last-child th": {
                                    border: 0,
                                },
                            }}
                        >
                            <TableCell sx={{ fontSize: '10px' }}>{++index}</TableCell>
                            <TableCell sx={{ fontSize: '10px', minWidth: '70px' }}>{locker.lockerNumber}</TableCell>
                            <TableCell sx={{ fontSize: '10px' }}>
                                <CatBtn bg="rgba(33, 150, 83, 0.2)" text="green" sx={{ fontSize: '10px' }}>
                                    {locker.lockerTypeName}
                                </CatBtn>
                            </TableCell>
                            <TableCell sx={{ fontSize: '10px' }}>
                                {locker?.discount}
                            </TableCell>
                            <TableCell sx={{ fontSize: '10px', minWidth: '150px' }}>
                                {locker?.renewDate ?? 'N/A'}
                            </TableCell>
                            <TableCell sx={{ fontSize: '10px', minWidth: '100px' }} >
                                {locker?.expiryDate ?? 'N/A'}
                            </TableCell>
                            <TableCell sx={{ position: 'relative' }}>
                                {locker?.isNewLockers
                                    ? <Typography sx={{ position: 'absolute', color: 'green', fontSize: '11px', top: '0px', right: '6px' }}>
                                        Newly Added
                                    </Typography>
                                    : null
                                }
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'between' }}>
                                    <Box sx={{
                                        background: getStatusColor(locker?.lockerstatus),
                                        marginRight: locker?.isSameLockerStatus ? "" : "4px",
                                        borderRadius: "6px", padding: '6px 12px',
                                        opacity: !locker?.isSameLockerStatus && ((!locker?.tempLockerstatus && locker?.tempLockerstatus === 0) || locker?.tempLockerstatus) ? "0.8" : "none",
                                        textDecoration: !locker?.isSameLockerStatus && ((!locker?.tempLockerstatus && locker?.tempLockerstatus === 0) || locker?.tempLockerstatus) ? "line-through" : "none",
                                        color: 'red'
                                    }}>
                                        <Typography sx={{ color: "white", fontWeight: '500', fontSize: '10px', }}>
                                            {LockerStatus[locker?.lockerstatus]}
                                        </Typography>
                                    </Box>
                                    {!locker?.isSameLockerStatus && (locker?.tempLockerstatus || locker?.tempLockerstatus === 0)
                                        ?
                                        <Box sx={{ background: getStatusColor(locker?.tempLockerstatus), borderRadius: "6px", padding: '6px 12px', }}>
                                            <Typography sx={{ color: "white", fontWeight: '500', fontSize: '10px' }}>
                                                {LockerStatus[locker?.tempLockerstatus]}
                                            </Typography>
                                        </Box>
                                        :
                                        null
                                    }

                                    {
                                        locker?.isVerified ? <Button variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#07bc0c', marginLeft: '4px', '&:hover': { backgroundColor: '#07bc0c', }, height: '24px', width: '80px' }}>
                                            <Verified fontSize={"small"} />
                                            <Typography style={{ marginLeft: '4px', fontSize: '10px' }}>Verified</Typography>
                                        </Button> : null
                                    }
                                    <a style={{ marginLeft: '4px', height: '20px', color: 'gray', cursor: 'pointer' }} href={`/lockers/${locker.lockerId}?isMainTable=${true}`} target="_blank" rel="noreferrer">
                                        <VisibilityIcon fontSize={"small"} />
                                    </a>

                                </Box>
                            </TableCell>
                        </TableRow>
                    )) : <TableRow>
                        <TableCell colSpan={5} align="center">No Data Found</TableCell>
                    </TableRow>}
                </TableBody>
            </Table>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={{ ...cancelStyle, width: 200 }} mt={10} textAlign={'center'}>
                    <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                        <Typography component='div' variant='h5'  >Are you sure you want to approve locker {lockerNumber}?</Typography>
                        <Typography variant='body2' component='span' sx={{ marginTop: '10px' }}>If cancel, all the unsaved work will be discarded.</Typography>
                        <Stack direction={'row'} gap={2} >
                            <LoadingButton loading={isLoading} onClick={handleApproveLocker} variant='contained' color='success'>Yes</LoadingButton>
                            <Button onClick={handleClose} variant='contained' color='error'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>
        </TableContainer>
    );
}